module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAAXNSR0IArs4c6QAAAStJREFUOE+tkztLBDEUhb87i4usWPgHBOstRNhGsFJsBB+NjbWNsIKwsFpuqYUoKNhY29gIgo1oJdgIIji1sH9AUHygzFyZJOK4MxlwMF1yc76c5J4IPUNn1+uILiNMA8Ou3EU5R+VQTrfCtES+J7rYqfL5vo1GKyCVXrCda4RUDujrb8lx5yNZMQArfjtDdSpfmFm9oFqbSSAWsLCxh8bNzDbRJXuwHGVrwb6cbK6KuXMQ3+XalqBhAfFN1plGxMGo6Fx7B2Et13ohIAGzKzrfvgfqpQAQJoAnYLAk4LkYoEwasHDp6Y4B+K8Aj0445AGExY+oXDkHE7kA84j+NnYZq40Y4e3rQyrWjuXa6A2S8oLIuM2BXiMM/HIhLkj/EuUfSMnPlLb21+/8BabwkC0juNo5AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/tk/tip.png
// module id = EVpw
// module chunks = 0